/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
//This file has been manually updated

const awsmobile = {
    "aws_project_region": "us-east-1",
    // "aws_cognito_identity_pool_id": "us-east-1:b23df7da-ae06-4415-bc3c-67852a59fe4e",
    "aws_cognito_identity_pool_id": "us-east-1:682f104c-0774-469b-b9d1-68d38dc6c4c3",
    "aws_cognito_region": "us-east-1",
    // "aws_user_pools_id": "us-east-1_5dbd9eFzh",  //prod
    "aws_user_pools_id": "us-east-1_tCvxDBjXY",  //dev
    // "aws_user_pools_web_client_id": "3hcefgti0aolntdve5afp47lff",
    "aws_user_pools_web_client_id": "jnm09uio0rmfnu2lnbsc9ecio",
    "oauth": {},
    // "aws_user_files_s3_bucket": "cardgallery-main150335-prod",
    "aws_user_files_s3_bucket": "cardgallery-main162223-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "CardCatalog",
            "region": "us-east-1"
        },
        {
            "tableName": "CardData",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://kflme3oidndorhzua7we4fq3h4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
